'use strict';

(function (global) {
  /**
   * Класс встроенной подсказки.
   *
   * @class WebAccess.components.notifications.ReactInlineHint
   * @extend BaseReactObject
   * @since 5.6.0.1300
   */
  var ReactInlineHint = BaseReactObject.extend({

    /**
     * Конструктор.
     *
     * @ignore
     * @method WebAccess.components.notifications.ReactInlineHint#init
     * @param {object} model Модель панели действий.
     * @override
     * @see BaseReactObject#init
     */
    init: function (model) {
      this._super(model);
    },

    /**
     * Имя класса.
     *
     * @private
     * @property WebAccess.components.notifications.ReactInlineHint#className
     * @override
     * @see BaseReactObject#className
     */
    className: 'ReactInlineHint',

    /**
     * Показывает встроенную подсказку с предупреждением.
     *
     * @method WebAccess.components.notifications.ReactInlineHint#showWarning
     * @param {string} msg Основной текст предупреждения.
     * @param  {string} [opt_details] Текст, объясняющий суть предупреждения.
     * @returns {WebAccess.components.notifications.ReactInlineHint} Текущий объект сообщения.
     */
    showWarning: function (msg, opt_details) {
      this.show(msg, opt_details, MESSAGE_TYPE.WARNING);
      return this;
    },

    /**
     * Показывает встроенную подсказку с текстом ошибки.
     *
     * @method WebAccess.components.notifications.ReactInlineHint#showError
     * @param {string} msg Основной текст ошибки.
     * @param  {string} [opt_details] Текст, объясняющий причину ошибки.
     * @returns {WebAccess.components.notifications.ReactInlineHint} Текущий объект сообщения.
     */
    showError: function (msg, opt_details) {
      this.show(msg, opt_details, MESSAGE_TYPE.ERROR);
      return this;
    },

    /**
     * Показывает встроенную подсказку с информационным сообщением.
     *
     * @method WebAccess.components.notifications.ReactInlineHint#showInfo
     * @param {string} msg Основной текст сообщения.
     * @param  {string} [opt_details] Текст, объясняющий суть подсказки.
     * @returns {WebAccess.components.notifications.ReactInlineHint} Текущий объект сообщения.
     */
    showInfo: function (msg, opt_details) {
      this.show(msg, opt_details, MESSAGE_TYPE.INFO);
      return this;
    },

    /**
     * Показывает подсказку в диалоге.
     *
     * @method WebAccess.components.notifications.ReactInlineHint#showInDialog
     * @param {string} dialogId ИД диалога.
     * @param {string} message Основной текст подсказки.
     * @param  {string} [opt_details] Дополнительная информация.
     * @param  {MESSAGE_TYPE} [opt_messageType] Тип сообщения.
     * @returns {WebAccess.components.notifications.ReactInlineHint} Текущий объект сообщения.
     */
    showInDialog: function (dialogId, message, opt_details, opt_messageType) {
      // В диалогах нет "реактивного" сообщения об ошибке
      // Используем обычное сообщение об ошибке
      (new global.InlineHint()).showInDialog(dialogId, message, opt_details, opt_messageType);
      this.show(message, opt_details, opt_messageType);
      return this;
    },

    /**
     * Показывает встроенную подсказку.
     *
     * @method WebAccess.components.notifications.ReactInlineHint#show
     * @param {string} message Основной текст подсказки.
     * @param  {string} [opt_details] Дополнительная информация.
     * @param {MESSAGE_TYPE} [opt_messageType] Тип сообщения.
     * @returns {WebAccess.components.notifications.ReactInlineHint} Текущий объект сообщения.
     */
    show: function (message, opt_details, opt_messageType) {
      this._model.caption = message ? message.replace('^', '<br />') : '';
      this._model.text = opt_details || '';
      this._model.type = opt_messageType;
      this._model.extended = {
        hide: function () {
          WA.CR.inlineHint.hide();
        }
      };
      this.fire(this['class'].EVENT.CHANGE_STATE, this._model);
      return this;
    },

    /**
     * Скрывает встроенную подсказку.
     *
     * @method WebAccess.components.notifications.ReactInlineHint#hide
     * @returns {WebAccess.components.notifications.ReactInlineHint} Текущий объект сообщения.
     */
    hide: function () {
      var me = this;
      for (var key in me._model) {
        delete me._model[key];
      }

      this.fire(this['class'].EVENT.CHANGE_STATE, this._model);
      return this;
    }
  }, {
    EVENT: {
      // Событие, срабатывающее при изменении модели встроенной подсказки.
      CHANGE_STATE: 'ReactInlineHintChange'
    }
  });
  global.ReactInlineHint = ReactInlineHint;
})(window.WebAccess.components.notifications);